// AI-generated place info section keys (for progressive loading)
export const all = ['placeInfo']

export const detail = (googlePlaceId: string) =>
  ['placeDetail', googlePlaceId]

export const overview = (googlePlaceId: string, chatId?: number) =>
  ['placeOverview', googlePlaceId, ...(chatId !== undefined ? [chatId] : [])]

export const bestTimeToVisit = (googlePlaceId: string, chatId?: number) =>
  ['placeBestTimeToVisit', googlePlaceId, ...(chatId !== undefined ? [chatId] : [])]

export const whatToLove = (googlePlaceId: string, chatId?: number) =>
  ['placeWhatToLove', googlePlaceId, ...(chatId !== undefined ? [chatId] : [])]

export const areas = (googlePlaceId: string, chatId?: number) =>
  ['placeAreas', googlePlaceId, ...(chatId !== undefined ? [chatId] : [])]

export const insiderTips = (googlePlaceId: string, chatId?: number) =>
  ['placeInsiderTips', googlePlaceId, ...(chatId !== undefined ? [chatId] : [])]

export const info = (googlePlaceId: string) =>
  ['placeInfo', googlePlaceId]

export const highlights = (googlePlaceId: string) =>
  ['placeHighlights', googlePlaceId]
